import { type AnnouncementMediaItem, getAnnouncementMediaSource } from '@air/feature-announcements';

/** Media is hidden when the environment has no bucket set, rather than pointing at another environment's files. */
export const getAnnouncementMediaForApp = (media: readonly AnnouncementMediaItem[]) => {
  return getAnnouncementMediaSource(media, process.env.NEXT_PUBLIC_ANNOUNCEMENT_MEDIA_BUCKET);
};
